/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content1/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Content from './Content/index'
import Footer from './Footer/index'
import Header from './Header/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content1({
  children,
  viewPath = "/DesignSystem/GenerateLettersModal/Content/Letters/Letter/Actions/CreateTaskAction/CreateTaskModal/Content"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 width="600px"
 height="85vh"
 paddingBottom={0}
 paddingLeft={0}
 paddingRight={0}
 paddingTop={dtSpaceS}
 dangerouslyBypassFocusLock={true}
>
{childProps => (
<React.Fragment>
<Header
{...childProps}
  viewPath={`${viewPath}/Header`}
/>
<Content
{...childProps}
  viewPath={`${viewPath}/Content`}
/>
<Footer
{...childProps}
  viewPath={`${viewPath}/Footer`}
/>
</React.Fragment>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}